import type { Resource } from '../../';
export const footer_cookiePreferences: Resource = {"default":"Cookie Preferences"};
